import { render, staticRenderFns } from "./RectangleAttr.vue?vue&type=template&id=48a708ea&scoped=true"
import script from "./RectangleAttr.vue?vue&type=script&lang=js"
export * from "./RectangleAttr.vue?vue&type=script&lang=js"
import style0 from "./RectangleAttr.vue?vue&type=style&index=0&id=48a708ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a708ea",
  null
  
)

export default component.exports